module.exports = __webpack_public_path__ + "img/empty-state.100b23a4.svg";